module.exports = __webpack_public_path__ + "static/media/DSC_0207.5c229459.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0207.jpg
// module id = 646
// module chunks = 0